import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const RateTemplete = () => {

  const [formData, setFormData] = useState({
    pincode: "",
    months: "",
    rate: "",
    
    
  });

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const apiUrl = "https://api.kalmesh.in/BabyStepsAPI";
  
    try {
      // api token fetch
      const apiToken = sessionStorage.getItem("api_token");
  
      if (!apiToken) {
        console.error("API Token not found in session storage");
        return;
      }
  
      // Save data Code
      const response = await fetch(`${apiUrl}/create-rate-template`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          su_id: 1,
          api_token: apiToken,
          trans_from: "SUPER_ADMIN",
          ...formData,
        }),
      });
  
      if (response.ok) {
        const responseData = await response.json();
        console.log("Data submitted successfully", responseData);
        
      if (responseData.status === "success") {
        // Display data from the API response on the console
        console.log("Rate Added Successfully");
        toast.success("Rate Added successfully",{ autoClose: 1000 });


        // ..........<Clear Form Feilds>.........
        const form = e.target;
        Array.from(form.elements).forEach((element) => {
          if (element.tagName === "INPUT" || element.tagName === "SELECT" || element.tagName === "TEXTAREA") {
            element.value = "";
          }
        });
        
      } else {
        console.error("Failed to Add Rate", response.statusText);
        // Display error toast notification
        toast.error("Failed to Add Rate",{ autoClose: 1000 });
      }
        // Redirect to the page after successful update
       
      } else {
        console.error("Failed to submit data", response.statusText);
      }
    } catch (error) {
      console.error("Error occurred while submitting data", error);
      // Display error toast notification
      toast.error("Error occurred while submitting data",{ autoClose: 1000 });
    }
  };
  
  
  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <h1 className="h3 mb-4 text-gray-800">Add Rate Template</h1>
              <div className="card">
                <div className="card-header">Add Rate Template</div>
                <div className="card-body" style={{ background: "white" }}>
                  <form onSubmit={handleSubmit}>
                    <div className="container">
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Pin Code</label>
                            <input
                              type="number"
                              name="pincode"
                              className="form-control"
                              placeholder="Enter Pin Code"
                              value={formData.pincode}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Months</label>
                            <input
                              type="number"
                              name="months"
                              className="form-control"
                              placeholder="Enter Month"
                              value={formData.months}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <label>Rate</label>
                            <input
                              type="text"
                              name="rate"
                              className="form-control"
                              placeholder="Enter Rate"
                              value={formData.rate}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <label></label>
                          <div className="row">
                            <div className="col-sm-6"></div>
                            <div className="col-sm-6">
                        <button
                        type="submit"
                        className="btn btn-primary"
                        style={{ marginLeft: "5px", marginRight: "5px", float:"right" }}
                      >
                        Add Rate
                      </button>
                      </div>
                      </div>
                        </div>
                      </div>
                      
                      
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
